import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiFileText, FiCreditCard, FiEye, FiLink, FiShield, FiBook} = FiIcons;

const LexwareAdvantagesSection = () => {
  const advantages = [
    {
      icon: FiFileText,
      title: 'Belege digital erfassen',
      description: 'Du fotografierst Belege einfach ab oder lädst sie hoch. Das System ordnet sie automatisch zu.'
    },
    {
      icon: FiCreditCard,
      title: 'Rechnungen schreiben',
      description: 'Du erstellst Rechnungen schnell und einheitlich – ohne Vorlagenchaos und ohne Nummernfehler.'
    },
    {
      icon: FiEye,
      title: 'Konten und Zahlungen im Blick',
      description: 'Bankverbindungen werden angebunden. Offene und bezahlte Rechnungen erkennst du auf einen Blick.'
    },
    {
      icon: FiLink,
      title: 'Überblick über Einnahmen und Ausgaben',
      description: 'Du siehst jederzeit, wie dein Monat finanziell läuft – ohne erst alles zusammensuchen zu müssen.'
    },
    {
      icon: FiShield,
      title: 'GoBD-konforme Ablage',
      description: 'Die Ablage ist rechtssicher und nachvollziehbar – ohne dass du dich mit Details befassen musst.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Was wir in Lexware Office für dich einrichten
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8 mb-12">
          {advantages.map((advantage, index) => (
            <motion.div
              key={index}
              initial={{opacity: 0, y: 30}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: index * 0.1}}
              viewport={{once: true}}
              className="bg-[#F3F1EE] p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 text-center"
            >
              <div className="mb-4 flex justify-center">
                <SafeIcon icon={advantage.icon} className="text-[#E30613] text-4xl" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{advantage.title}</h3>
              <p className="text-gray-600 text-sm">{advantage.description}</p>
            </motion.div>
          ))}
        </div>
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.3}}
          viewport={{once: true}}
          className="text-center"
        >
          <div className="bg-[#F3F1EE] p-6 rounded-xl shadow-lg max-w-md mx-auto">
            <div className="flex items-center justify-center mb-4">
              <SafeIcon icon={FiBook} className="text-[#E30613] text-4xl" />
            </div>
            <p className="text-gray-700 mb-4">
              Mehr Funktionen findest du hier im
            </p>
            <motion.a
              href="#/lexware-abc"
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
              className="bg-[#E30613] hover:bg-[#C10511] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300"
            >
              Lexware ABC
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LexwareAdvantagesSection;